import { ReactElement } from 'react'
import s from './ReviewComment.module.scss'
import { translateRatingToDecimal } from '@lib/utils/translateRatingToDecimal'
import { ReviewStars } from '@components/Reviews/ReviewStars'
import { ProductReview } from '@pylot-data/pylotschema'
import { dateParser } from '@lib/utils/dateParser'

type ReviewCommentProps = {
    comment: ProductReview
}

const ReviewComment = ({
    comment
}: ReviewCommentProps): ReactElement | null => {
    const { average_rating, created_at, text, nickname } = comment

    const date = dateParser(created_at)
    return (
        <div className={s['comment-container']}>
            <div className={s['comment-info']}>
                <div className={s['comment-rating']}>
                    <ReviewStars rating={average_rating} />
                    {translateRatingToDecimal(average_rating)}
                </div>
                {date}
            </div>
            {!nickname?.includes('@') && (
                <div className={s['comment-name']}>{nickname}</div>
            )}
            <div className={s['comment-review']}>{text}</div>
        </div>
    )
}

export default ReviewComment
